// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 24px;
}

.admin-dashboard-header {
  margin-bottom: 48px;
}

.admin-dashboard-header h1 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 8px;
}

.admin-dashboard-header .subtitle {
  color: var(--primary-color-dark);
  font-size: 18px;
}

.dashboard-section {
  background: var(--accent-color-dark);
  border-radius: 8px;
  padding: 32px;
  margin-bottom: 32px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--secondary-color-dark);
}

.section-header h2 {
  font-size: 28px;
  font-weight: bold;
  color: var(--secondary-color-dark);
}

.action-button {
  padding: 12px 24px;
  background: var(--primary-color-dark);
  color: white;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  transition: all 0.2s ease;
}

.action-button:hover {
  background: var(--secondary-color-dark);
  transform: translateY(-2px);
}

.dashboard-card {
  background: var(--background-color-dark);
  border: 1px solid var(--secondary-color-dark);
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
}

.dashboard-card:hover {
  border-color: var(--primary-color-dark);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.card-meta {
  color: var(--primary-color-dark);
  font-size: 14px;
}

.card-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

.card-link {
  color: var(--primary-color-dark);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.card-link:hover {
  color: var(--secondary-color-dark);
}

.empty-state {
  text-align: center;
  padding: 48px;
  color: var(--primary-color-dark);
  font-size: 16px;
}

.loading-state, .error-state {
  text-align: center;
  padding: 48px;
  font-size: 18px;
}

.error-state {
  color: #ff6b6b;
}

/* User Management Styles */
.user-role-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
}

.user-role-badge.role-admin {
  background: #ff6b6b;
  color: white;
}

.user-role-badge.role-investor {
  background: #51cf66;
  color: white;
}

.user-role-badge.role-user {
  background: #868e96;
  color: white;
}

.role-selector {
  padding: 6px 12px;
  background: var(--background-color-dark);
  border: 1px solid var(--secondary-color-dark);
  border-radius: 4px;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

.role-selector:hover {
  border-color: var(--primary-color-dark);
}

.update-role-button {
  padding: 6px 16px;
  background: var(--primary-color-dark);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
}

.update-role-button:hover:not(:disabled) {
  background: var(--secondary-color-dark);
}

.update-role-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.success-message {
  padding: 12px 16px;
  background: #51cf66;
  color: white;
  border-radius: 5px;
  margin-bottom: 16px;
  font-weight: 500;
}

.user-grid {
  display: grid;
  gap: 12px;
}

`, "",{"version":3,"sources":["webpack://./client/components/pages/Dashboard/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":[".admin-dashboard {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 48px 24px;\n}\n\n.admin-dashboard-header {\n  margin-bottom: 48px;\n}\n\n.admin-dashboard-header h1 {\n  font-size: 42px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.admin-dashboard-header .subtitle {\n  color: var(--primary-color-dark);\n  font-size: 18px;\n}\n\n.dashboard-section {\n  background: var(--accent-color-dark);\n  border-radius: 8px;\n  padding: 32px;\n  margin-bottom: 32px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid var(--secondary-color-dark);\n}\n\n.section-header h2 {\n  font-size: 28px;\n  font-weight: bold;\n  color: var(--secondary-color-dark);\n}\n\n.action-button {\n  padding: 12px 24px;\n  background: var(--primary-color-dark);\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-block;\n  transition: all 0.2s ease;\n}\n\n.action-button:hover {\n  background: var(--secondary-color-dark);\n  transform: translateY(-2px);\n}\n\n.dashboard-card {\n  background: var(--background-color-dark);\n  border: 1px solid var(--secondary-color-dark);\n  border-radius: 5px;\n  padding: 20px;\n  margin-bottom: 16px;\n  transition: all 0.2s ease;\n}\n\n.dashboard-card:hover {\n  border-color: var(--primary-color-dark);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.card-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.card-meta {\n  color: var(--primary-color-dark);\n  font-size: 14px;\n}\n\n.card-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.card-link {\n  color: var(--primary-color-dark);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.card-link:hover {\n  color: var(--secondary-color-dark);\n}\n\n.empty-state {\n  text-align: center;\n  padding: 48px;\n  color: var(--primary-color-dark);\n  font-size: 16px;\n}\n\n.loading-state, .error-state {\n  text-align: center;\n  padding: 48px;\n  font-size: 18px;\n}\n\n.error-state {\n  color: #ff6b6b;\n}\n\n/* User Management Styles */\n.user-role-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.user-role-badge.role-admin {\n  background: #ff6b6b;\n  color: white;\n}\n\n.user-role-badge.role-investor {\n  background: #51cf66;\n  color: white;\n}\n\n.user-role-badge.role-user {\n  background: #868e96;\n  color: white;\n}\n\n.role-selector {\n  padding: 6px 12px;\n  background: var(--background-color-dark);\n  border: 1px solid var(--secondary-color-dark);\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.role-selector:hover {\n  border-color: var(--primary-color-dark);\n}\n\n.update-role-button {\n  padding: 6px 16px;\n  background: var(--primary-color-dark);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.update-role-button:hover:not(:disabled) {\n  background: var(--secondary-color-dark);\n}\n\n.update-role-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.success-message {\n  padding: 12px 16px;\n  background: #51cf66;\n  color: white;\n  border-radius: 5px;\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n\n.user-grid {\n  display: grid;\n  gap: 12px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
